import { getUser } from "@/utils/auth";
import { configBySlug } from "@/api/login";
import {
  addProduct, getAuditory, saveAdjustInputOutput,
  getAdjustInputOutputPending, deleteRowDetail, updateAdjustInputOutput
} from "@/api/inputOutputAdjust";
import { getDocumentById } from "@/api/document";
const defaultState = () => {
  return {
    response: { type: null },
    editing: false,
    refreshCodeBranch: false,
    closeModalTransfer: false,
    inventoryAuditId: null,
    document: {
      type: null,
      id: null,
      userId: null,
      thirdId: null,
      numDays: null,
      date: new Date().toISOString().split('T')[0],
      consecutive: null,
      observation: null,
      document_reference: null,
      branch: (getUser()) ? parseInt(getUser().sucursal_id) : null,
      branchDestinationId: null,
      codeBranch: null,
      costCenterId: null
    },
    detail: [],
    pending: [],
    // print
    dataPrint: null,
    execute: false,
  }
}
export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    SET_CLOSE_MODAL_TRANSFER: (state, connect) => {
      state.closeModalTransfer = connect
    },
    SET_REFRESH_CODE_BRANCH: (state, connect) => {
      state.refreshCodeBranch = connect
    },
    SET_EDITING: (state, connect) => {
      state.editing = connect
    },
    SET_THIRD_ID: (state, connect) => {
      state.document.thirdId = connect
    },
    SET_DATE: (state, connect) => {
      state.document.date = connect
    },
    SET_NUM_DAYS: (state, connect) => {
      state.document.numDays = connect
    },
    SET_DATE: (state, connect) => {
      state.document.date = connect
    },
    SET_OBSERVATION: (state, connect) => {
      state.document.observation = connect
    },
    SET_DOCUMENT_REFERENCE: (state, connect) => {
      state.document.document_reference = connect
    },
    SET_RESPONSE: (state, connect) => {
      state.response = connect
    },
    SET_AUDITORY_ID: (state, connect) => {
      state.inventoryAuditId = connect
    },
    SET_DOCUMENT_ID: (state, connect) => {
      state.document.id = connect
    },
    SET_PENDING: (state, connect) => {
      state.pending = connect
    },
    SET_DOCUMENT: (state, connect) => {
      state.document = connect
    },
    SET_BRANCH: (state, connect) => {
      state.document[connect.type] = connect.value
    },
    SET_COST_CENTER: (state, connect) => {
      state.document.costCenterId = connect
    },
    SET_CODE_BRANCH: (state, connect) => {
      state.document.codeBranch = connect
    },
    SET_DETAIL: (state, connect) => {
      state.detail = []
      connect.detail.forEach((element) => {
        state.detail.push({
          auditoryId: connect.id,
          detailId: element.id,
          productId: element.product.id,
          code: element.product.codigo,
          description: element.descripcion,
          quantity: element.cantidad,
          in_location: element.in_location,
          sale_price: element.product.precio_venta,
          sale_price_edit: element.price,
          cost: element.product.costo,
          observation: (connect.id) ? element.observation : element.observacion,
        });
      });
    },
    RESET_DOCUMENT: (state) => {
      Object.assign(state, defaultState())
      state.refreshCodeBranch = true
    },
    SET_DATA_PRINT: (state, connect) => {
      state.dataPrint = connect
    },
    SET_EXECUTE: (state, connect) => {
      state.execute = connect
    },
  },
  actions: {
    async addProductAction({ commit, state, rootState }, params) {
      try {
        commit('SET_RESPONSE', { type: null }, { root: true })
        let productInList = state.detail.find((d) => d.code === params.code);
        if (productInList) {
          params.quantity = parseInt(params.quantity) + parseInt(productInList.quantity);
        }
        let branchId = (params.branchId) ? params.branchId : state.document.branch
        let data = await addProduct(
          params.code,
          params.quantity,
          params.price,
          params.observation,
          params.type,
          params.typeDocument,
          params.in_location,
          branchId,
          // state.document.branch,
          rootState.core.logged.id,
          state.inventoryAuditId,
          state.editing,
          state.document.id,
          state.document.thirdId,
          state.document.numDays,
          state.document.observation,
          state.document.document_reference,
          state.document.costCenterId
        )
        if (data.data["auditory"])
          commit('SET_AUDITORY_ID', data.data["auditory"]["id"])
        if (data.data.auditory) {
          commit('SET_DETAIL', data.data.auditory)
          return;
        } else if (data.data.detail) {
          commit('SET_DETAIL', data.data)
          return;
        }
        commit('SET_RESPONSE', { type: 'error', msg: data.data }, { root: true })

      } catch (error) {
        console.error('Error:' + error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Error al agregar el producto' }, { root: true })
      }
    },
    async selectAdjustPendingAction({ commit, state }, params) {
      try {
        let data = await getAuditory(params.auditoryId)
        if (data.data.auditory) {
          commit('SET_AUDITORY_ID', params.auditoryId)
          commit('SET_DOCUMENT', {
            type: data.data.auditory.tipo_documento_id,
            id: null,
            thirdId: data.data.auditory.tercero_id,
            numDays: data.data.auditory.dias,
            date: data.data.auditory.fecha,
            observation: data.data.auditory.observacion,
            document_reference: data.data.auditory.document_reference,
            branch: parseInt(data.data.auditory.bodega_id),
            codeBranch: '',
            costCenterId: (data.data.auditory.cost_center_id) ? parseInt(data.data.auditory.cost_center_id) : null
          })
          commit('SET_DETAIL', data.data.auditory)
          if (data.data.auditory.third) {
            commit('third/SET_THIRD', { value: data.data.auditory.third, prop: 'all' }, { root: true })
          }
        }
        commit('SET_REFRESH_CODE_BRANCH', true)
      } catch (error) {
        console.error('Error:' + error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Error al seleccionar ajuste pendiente' })
      }
    },
    async editDocumentAction({ commit }, documentId) {
      try {
        commit('SET_DOCUMENT_ID', documentId)
        let data = await getDocumentById(documentId)
        commit('third/SET_THIRD', { value: data.data.document.person, prop: 'all' }, { root: true })
        commit('SET_DOCUMENT', {
          type: data.data.document.tipo_id,
          id: data.data.document.id,
          consecutive: data.data.document.consecutivo,
          thirdId: data.data.document.person.id,
          numDays: data.data.document.dias,
          date: data.data.document.fecha,
          observation: data.data.document.observacion,
          document_reference: data.data.document.document_reference,
          branch: parseInt(data.data.document.sucursal_id),
          branchDestinationId: data.data.document.branch_destination,
          codeBranch: '',
          costCenterId: (data.data.document.cost_center_id) ? parseInt(data.data.document.cost_center_id) : null
        })
        commit('SET_DETAIL', data.data)
        commit('SET_DATA_PRINT', data.data)
        commit('SET_EDITING', true)
        commit('SET_AUDITORY_ID', false)
        commit('SET_REFRESH_CODE_BRANCH', true)
      } catch (error) {
        console.error('Error:' + error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Error al editar el ajuste' })
      }
    },
    async updateDocumentAction({ commit, state, dispatch }, typeDocument) {
      try {
        commit('SET_EXECUTE', false)
        if (state.detail.length == 0) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar productos para actualizar el documento.' })
          return false
        }
        if (!state.document.date) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar una fecha para actualizar el documento.' })
          return false
        }
        if (state.document.thirdId == null) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar un tercero para actualizar el documento.' })
          return false
        }
        let document = await updateAdjustInputOutput(
          state.document
        )
        // print
        if (document.data.code === 200) {
          dispatch('setDataPrintAction', document.data.data)

          setTimeout(() => {
            dispatch('resetAction')
          }, 500);
          dispatch('getPendingAction', typeDocument)
          commit('SET_RESPONSE', { type: 'success', msg: 'Documento actualizado.' })
          commit('SET_EXECUTE', true)
        } else {
          commit('SET_RESPONSE', { type: 'warning', msg: document.data.error }, { root: true })
        }
      } catch (error) {
        console.error('Error:' + error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Ocurrió un error' })
      }
    },
    async saveDocumentAction({ commit, state, rootState, dispatch }, params) {
      try {
        commit('SET_EXECUTE', false)
        if (state.detail.length == 0) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar productos para guardar el documento.' }, { root: true })
          return false
        }
        if (!state.document.date) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar una fecha para guardar el documento.' }, { root: true })
          return false
        }
        if (state.document.thirdId == null) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe agregar un tercero para guardar el documento.' }, { root: true })
          return false
        }
        if (state.document.branch == null) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe seleccionar una bodega para guardar el documento.' }, { root: true })
          return false
        }
        // if (state.document.costCenterId == null) {
        //   commit('SET_RESPONSE', { type: 'error', msg: 'Debe seleccionar un centro de costos.' }, { root: true })
        //   return false
        // }
        if (params.typeDocument === 3 && state.document.branchDestinationId == null) {
          commit('SET_RESPONSE', { type: 'error', msg: 'Debe seleccionar una bodega destino.' }, { root: true })
          return false
        }
        let document = await saveAdjustInputOutput(
          state.document,
          state.inventoryAuditId,
          rootState.core.logged.id,
          state.document.branch,
          params.type,
          params.typeDocument,
          state.document.costCenterId
        )
        // print
        if (document.data.code === 200) {
          dispatch('setDataPrintAction', document.data.data)
          setTimeout(() => {
            dispatch('resetAction')
          }, 500);
          dispatch('getPendingAction', params.typeDocument)
          commit('SET_RESPONSE', { type: 'success', msg: 'Documento guardado.' }, { root: true })
          commit('SET_EXECUTE', true)
          if (params.typeDocument === 3) {
            commit('SET_CLOSE_MODAL_TRANSFER', true)
          }
        } else {
          commit('SET_RESPONSE', { type: 'warning', msg: document.data.error }, { root: true })
        }
      } catch (error) {
        console.error('Error action store:' + error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Ocurrió un error' }, { root: true })
      }
    },
    async getPendingAction({ commit, state, rootState }, typeDocument) {
      try {
        let data = await getAdjustInputOutputPending(rootState.core.logged.branch.id, typeDocument)
        commit('SET_PENDING', data.data.auditory)
      } catch (error) {
        console.log(error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Error al validar ajustes pendientes.' }, { root: true })
      }
    },
    async deleteRowAction({ commit, state, dispatch, rootState }, row) {
      try {
        let data = await deleteRowDetail(row.detailId, row.productId, rootState.core.logged.branch.id, state.editing)
        if (state.editing) {
          dispatch('editDocumentAction', state.document.id)
        } else {
          dispatch('selectAdjustPendingAction', row)
        }
        (data.code == 200) ?
          commit('SET_RESPONSE', { type: 'success', msg: 'Registro eliminado.' })
          : commit('SET_RESPONSE', { type: 'error', msg: data.msg })
      } catch (error) {
        console.log(error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Error al eliminar registro.' })
      }
    },
    async setDataPrintAction({ commit }, documentId) {
      try {
        if (documentId) {
          commit('SET_DOCUMENT_ID', documentId)
          let data = await getDocumentById(documentId)
          commit('SET_DATA_PRINT', data.data)
        } else {
          commit('SET_DATA_PRINT', null)
        }
      } catch (error) {
        console.error('Error:' + error);
        commit('SET_RESPONSE', { type: 'error', msg: 'Error al imprimir' })
      }
    },
    resetAction({ commit, dispatch }) {
      commit('RESET_DOCUMENT')
      commit('third/RESET_THIRD', null, { root: true })
    },
  }
}
